export default __webpack_public_path__ + "static/featured-image-0a02b55f28d69829f7b08530d39410be.png";